import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppError } from '../error/app-error';
import { ToastService } from '../services/toast.service';

function isApiRequest(url: string): boolean {
  return url.startsWith(environment.apiBaseUrl);
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  const transloco = inject(TranslocoService);

  if (!isApiRequest(req.url)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((err: unknown) => {
      if (!(err instanceof HttpErrorResponse)) {
        return throwError(() => AppError.from(err));
      }

      // 401s are owned by authInterceptor (refresh + logout).
      if (err.status === 401) {
        return throwError(() => AppError.from(err));
      }

      const appError = AppError.from(err);

      if (err.status === 0 || err.status >= 500) {
        const isOffline = err.status === 0;
        toast.error({
          title: transloco.translate(
            isOffline ? 'common.error.networkTitle' : 'common.error.serverTitle',
          ),
          description: transloco.translate(
            isOffline ? 'common.error.networkBody' : 'common.error.serverBody',
          ),
        });
        return throwError(() => appError.markHandled());
      }

      // 4xx rethrown silently for inline feature handling.
      return throwError(() => appError);
    }),
  );
};
